import {
  CreateInvoiceEntity,
  InvoiceEntity,
} from '@/pages/privatePages/invoice/types';
import APIService from './axios.service';
import { BaseService } from './base.service';

class InvoiceServiceClass extends BaseService<
  'invoice',
  InvoiceEntity,
  CreateInvoiceEntity
> {
  constructor() {
    super('invoice');
  }

  checkPreInvoicing = (payload: {
    projectId: string;
    productIds: string[];
  }): Promise<boolean> => {
    return APIService.post(
      `${this.path}/should-show-pre-invoicing-modal`,
      payload,
    );
  };
}
export const invoiceService = new InvoiceServiceClass();
